import { Observable } from "rxjs";
import { AuthService } from "./shared/services/common/auth.service";

export function applicationInitializerFactory(authService: AuthService): () => Observable<void> {
  return () => authService.configure();
}